import { useState } from 'react'
import { countDecimalsAndAdd0, formatAmount } from 'Utils/helperFunctions'

const TableBudgetsItem = ({ budgetSettings, budget, onAddBudget }) => {
  const [draft, setDraft] = useState(null)

  // The current per-task budget: the unsaved input if touched, else what's stored.
  const effectiveBudget = draft ?? (budget?.budget || 0)

  const unit = budgetSettings?.type?.startsWith('Fee') ? 'money' : 'hours'
  const loggedHours = budget?.spent || 0
  // Spend against the budget: money budgets value the hours at the task billable rate.
  const spentValue = unit === 'money' ? loggedHours * (budget?.billable || 0) : loggedHours

  const getPercent = ({ spent, budget }) => {
    if (spent === 0) return 0
    if (budget === 0) return 100
    return countDecimalsAndAdd0({ number: (spent * 100) / (budget) })
  }

  const getRest = ({ spent, budget }) => {
    return countDecimalsAndAdd0({ number: budget - spent })
  }

  const handleValueChange = (value) => {
    const numericValue = parseFloat(value) || 0
    setDraft(numericValue)
    if (onAddBudget) {
      onAddBudget({ idTask: budget?.task?.id, budget: numericValue })
    }
  }

  return (
        <tr className="table_row_color">
              <td className='text-no-wrap'>{budget?.task?.name || ''}</td>
              <td className='text-no-wrap'>{formatAmount({ value: spentValue, unit })}</td>
              <td className="text-no-wrap px-4">
                <span className="row justify-content-between">
                  <span className="col-auto">
                    <p className='small mb-1'>Budget: {formatAmount({ value: effectiveBudget, unit })}</p>
                  </span>
                  <span className="col-auto">
                    <p className='small mb-1'>Remaining: {formatAmount({ value: getRest({ spent: spentValue, budget: effectiveBudget }), unit })}</p>
                  </span>
                </span>
                <span className='row'>
                  <div className='col-12'>
                    <div
                      style={{ width: '100%', height: '4px' }}
                      className="progress"
                      role="progressbar"
                      aria-label="Budget used"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="100">
                        <div
                          className="progress-bar"
                          style={{
                            width: `${getPercent({ spent: spentValue, budget: effectiveBudget })}%`,
                            backgroundColor: '#31f7f2'
                          }}></div>

                        {spentValue > effectiveBudget && (
                            <div
                              className="progress-bar"
                              style={{
                                width: `${getPercent({ spent: spentValue - effectiveBudget, budget: effectiveBudget || 0 })}%`,
                                backgroundColor: '#BC5776ff'
                              }}
                            ></div>
                        )}
                    </div>
                  </div>
                </span>
              </td>
              <td className="width-150">
                <input
                  type='number'
                  className='form-control'
                  onChange={(e) => handleValueChange(e.target.value)}
                  defaultValue={budget?.budget || 0}
                  step="0.01"
                />
              </td>
            </tr>
  )
}
export default TableBudgetsItem
